import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import RatingWrapper from './RatingWrapper';
import MatrixHiddenInput from './MatrixHiddenInput';
import MatrixRatingIcon from './MatrixRatingIcon';
import MatrixWhy from '../response/MatrixWhy';
import * as Matrix from '../matrix/Matrix';
import range from 'lodash/range';

const MatrixRatingQuestion = props => {
  const {
    add_why,
    id,
    inputNamer = defaultInputNamer,
    isDisabled,
    name,
    rating_count,
    rating_shape,
    rows,
    why_text,
    _type,
  } = props;
  return (
    <QuestionWrapper {...props}>
      <Matrix.Table>
        {rows.map((row, rowIndex) => (
          <Matrix.Body key={rowIndex}>
            <Matrix.Row
              id={row.id}
              other={row.other}
              questionId={id}
              questionName={name}
              text={row.text}
            >
              <td>
                <div>
                  <MatrixHiddenInput
                    name={inputNamer(_type, name, row.name)}
                    questionId={id}
                    rowIndex={rowIndex}
                  />
                  <RatingWrapper disabled={isDisabled}>
                    {({
                      hoverVal,
                      hover,
                      onHoverOrFocus,
                      onBlurOrMouseLeave,
                    }) =>
                      range(rating_count).map(index => (
                        <MatrixRatingIcon
                          disabled={isDisabled}
                          key={index}
                          icon={rating_shape}
                          isHovered={hover}
                          hoverVal={hoverVal}
                          onHoverOrFocus={onHoverOrFocus}
                          onBlurOrMouseLeave={onBlurOrMouseLeave}
                          questionId={id}
                          rowIndex={rowIndex}
                          value={index + 1}
                        />
                      ))
                    }
                  </RatingWrapper>
                </div>
              </td>
            </Matrix.Row>
            <MatrixWhy
              add_why={add_why}
              colSpan="2"
              id={id}
              name={name}
              rowName={row.name}
              rowIndex={rowIndex}
              why_text={why_text}
            />
          </Matrix.Body>
        ))}
      </Matrix.Table>
    </QuestionWrapper>
  );
};

MatrixRatingQuestion.propTypes = {
  add_why: PropTypes.bool,
  id: PropTypes.string.isRequired,
  matrix: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  rating_count: PropTypes.number.isRequired,
  rating_shape: PropTypes.string.isRequired,
  required: PropTypes.bool,
  rows: PropTypes.array,
  text: PropTypes.string,
  value: PropTypes.number,
  why_text: PropTypes.string,
};

MatrixRatingQuestion.defaultProps = {
  rating_count: 5,
  rating_shape: 'star',
  rows: [],
};

export default MatrixRatingQuestion;

function defaultInputNamer(_type, questionName, rowName) {
  return `questions[${questionName}-${rowName}]`;
}
